export default {"src":"/_next/static/media/create-and-collaborate.1b13a1a4.gif","height":338,"width":600};